import type { PlayerPlayP2pClientConstructorParams } from '@genially/p2p-client';
import { PlayerPlayP2pClient } from '@genially/p2p-client';

export const createPlayerPlayP2pClient = (
  params: PlayerPlayP2pClientConstructorParams,
) => {
  return new PlayerPlayP2pClient(params);
};
